const form = require('./form.ejs');
const align = require('./align.ejs');

export default { form, align };